// DEMO progress — live amounts not publicly available (reCAPTCHA + 403 API). Post-MVP: replace this single function with the foundation ERP/API call.

const TARGETS = [5_000_000, 10_000_000, 15_000_000, 25_000_000, 50_000_000, 100_000_000];

/** Deterministic integer hash of a string (djb2-style). */
function hashStr(s: string): number {
  let h = 5381;
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) + h) ^ s.charCodeAt(i);
    h = h >>> 0; // keep unsigned 32-bit
  }
  return h;
}

export function getProgress(id: string): { percent: number; raised: number; target: number } {
  const h = hashStr(id);
  // TARGETS is a fixed non-empty array; modulo guarantees a valid index.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const target: number = TARGETS[h % TARGETS.length]!;
  // percent in [35, 95]
  const percent = 35 + ((h >>> 5) % 61);
  const raised = Math.round((target * percent) / 100);
  return { percent, raised, target };
}

/** Format a UAH amount: thin-space grouped, ₴ suffix. e.g. "25 000 000 ₴" */
export function formatUAH(n: number): string {
  //   = narrow no-break space (thin space grouping)
  return n.toLocaleString("uk-UA").replace(/\s/g, " ") + " ₴";
}
